// extracted by mini-css-extract-plugin
module.exports = {"image":"ImgComp_image__3tp6v","imgContainer":"ImgComp_imgContainer__1Upi-"};